export const GEO_MAP = 'GEO_MAP';
export const SITES_STATUS = {
    contacted: 'contacted',
    pursued: 'pursued',
    selected: 'selected'
};
